var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.789062,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#F1F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2187 29.695C38.2812 34.3825 34.7469 38.7963 29.7875 39.7825C27.3687 40.2642 24.8596 39.9705 22.6175 38.9433C20.3754 37.916 18.5145 36.2075 17.2998 34.0611C16.0851 31.9147 15.5786 29.4398 15.8523 26.9888C16.1261 24.5378 17.1661 22.2356 18.8244 20.41C22.2256 16.6638 27.9687 15.6325 32.6562 17.5075",
    stroke: "#2698EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2812 27.8203L27.9688 32.5078L39.2188 20.3203",
    stroke: "#2698EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCheck;